/*!
 * bm-popup-bienvenue.js - Pop-up de bienvenue -10 % - boutique Batman
 * v1.0.0 - 2026-10-06 - même moteur que le pop-up Spider-Man (en ligne depuis le 02/10)
 *
 * Chargé par sections/bm-popup-bienvenue.liquid, qui fournit :
 *   #bmpb-config         les réglages (JSON) : langue, code, délai…
 *   #bmpb-form-template  le formulaire d'inscription natif de Shopify (form 'customer')
 *
 * Tout est isolé dans un Shadow DOM : le CSS du thème ne peut pas déformer le pop-up,
 * et le pop-up ne modifie rien dans le thème. Aucune dépendance externe, aucun logo :
 * le ciel de Gotham, le bat-signal et la skyline sont dessinés ici.
 *
 * Tant que le pop-up Halloween est actif sur la page (#bmph-config), celui-ci reste en retrait.
 *
 * Contrôle par l'adresse de la page :
 *   ?bmpb=show   affiche le pop-up après 1 s, sans les règles d'affichage (inscription réelle)
 *   ?bmpb=test   idem, inscription simulée (jamais sur le thème en ligne)
 *   ?bmpb=reset  oublie ce que ce navigateur a mémorisé (fermé, inscrit, acheteur)
 */
(function () {
  'use strict';
  if (window.__bmpbBooted) return;
  window.__bmpbBooted = true;

  var VERSION = '1.0.0';
  var SECTION_ID = 'bm-popup-bienvenue';
  var MIN_AFTER_LOAD = 2500;   // jamais moins de 2,5 s après l'affichage d'une page
  var RETRY_BUSY = 3000;       // menu ouvert, recherche ouverte, saisie en cours : on réessaie
  var K = {
    sub: 'bmpb_sub',           // inscrit (ou arrivé depuis un e-mail) : plus jamais de pop-up
    snooze: 'bmpb_snooze',     // fermé : pas de pop-up avant cette date (ms)
    buyer: 'bmpb_buyer',       // a déjà commandé (posé par le pixel « acheteur »)
    t0: 'bmpb_t0',             // début de la visite (sessionStorage)
    shown: 'bmpb_shown',       // déjà montré pendant cette visite (sessionStorage)
    pending: 'bmpb_pending'    // inscription partie par la page de vérification Shopify
  };
  var EMAIL_RE = /^[^\s@<>(),;:\\[\]]+@[^\s@<>(),;:\\[\]]+\.[a-z\u00a1-\uffff]{2,}$/i;

  /* <T> textes (5 langues) — seul bloc avec des caractères accentués, échappés en \uXXXX à la livraison */
  var T = {
    fr: {
      dialog: 'Offre de bienvenue\u00a0: \u221210\u00a0%',
      pct: '\u221210\u00a0%', sub: 'sur ta premi\u00e8re commande',
      eyebrow: 'Offre de bienvenue', title: 'Rejoins la Bat-family\u202f!',
      text: 'Laisse ton e-mail\u00a0: ton code s\u2019affiche tout de suite. Ensuite, on te tient au courant des nouveaut\u00e9s de Gotham.',
      label: 'Ton adresse e-mail', placeholder: 'Ton adresse e-mail',
      cta: 'Je veux mes \u221210\u00a0%', sending: 'Un instant\u2026', decline: 'Non merci',
      legal: 'En t\u2019inscrivant, tu acceptes de recevoir nos e-mails (nouveaut\u00e9s et offres). D\u00e9sinscription en un clic. Offre valable une fois, sur une premi\u00e8re commande.',
      privacy: 'Politique de confidentialit\u00e9',
      errEmail: 'Cette adresse e-mail n\u2019a pas l\u2019air valide.',
      errNetwork: 'Oups, \u00e7a n\u2019a pas march\u00e9. R\u00e9essaie dans un instant.',
      okTitle: 'Bienvenue dans la Bat-family\u202f!', okText: 'Voici ton code de r\u00e9duction\u00a0:',
      copy: 'Copier', copied: 'Copi\u00e9\u202f!',
      okApplied: 'Il est d\u00e9j\u00e0 appliqu\u00e9 \u00e0 ton panier\u00a0: la r\u00e9duction s\u2019affichera au paiement.',
      okManual: 'Saisis-le au moment du paiement.',
      okNote: 'Valable une fois, sur ta premi\u00e8re commande.',
      cont: 'Continuer mes achats', close: 'Fermer'
    },
    en: {
      dialog: 'Welcome offer: 10% off',
      pct: '\u221210%', sub: 'on your first order',
      eyebrow: 'Welcome offer', title: 'Join the Bat-family!',
      text: 'Drop your email: your code appears instantly, and we\u2019ll keep you posted on everything new in Gotham.',
      label: 'Your email address', placeholder: 'Your email address',
      cta: 'Get my 10% off', sending: 'One moment\u2026', decline: 'No thanks',
      legal: 'By signing up, you agree to receive our emails (new arrivals and offers). Unsubscribe in one click. Valid once, on a first order.',
      privacy: 'Privacy policy',
      errEmail: 'This email address doesn\u2019t look valid.',
      errNetwork: 'Oops, that didn\u2019t work. Please try again in a moment.',
      okTitle: 'Welcome to the Bat-family!', okText: 'Here\u2019s your discount code:',
      copy: 'Copy', copied: 'Copied!',
      okApplied: 'It\u2019s already applied to your cart: you\u2019ll see the discount at checkout.',
      okManual: 'Enter it at checkout.',
      okNote: 'Valid once, on your first order.',
      cont: 'Continue shopping', close: 'Close'
    },
    de: {
      dialog: 'Willkommensangebot: 10\u00a0% Rabatt',
      pct: '\u221210\u00a0%', sub: 'auf deine erste Bestellung',
      eyebrow: 'Willkommensangebot', title: 'Werde Teil der Bat-Familie!',
      text: 'Gib deine E-Mail-Adresse ein: Dein Code erscheint sofort, und wir halten dich \u00fcber alle Neuheiten aus Gotham auf dem Laufenden.',
      label: 'Deine E-Mail-Adresse', placeholder: 'Deine E-Mail-Adresse',
      cta: 'Meine 10\u00a0% sichern', sending: 'Einen Moment\u00a0\u2026', decline: 'Nein, danke',
      legal: 'Mit deiner Anmeldung willigst du ein, unsere E-Mails (Neuheiten und Angebote) zu erhalten. Abmeldung jederzeit mit einem Klick. Einmal g\u00fcltig, nur bei einer Erstbestellung.',
      privacy: 'Datenschutzerkl\u00e4rung',
      errEmail: 'Diese E-Mail-Adresse scheint ung\u00fcltig zu sein.',
      errNetwork: 'Hoppla, das hat nicht geklappt. Bitte versuche es gleich noch einmal.',
      okTitle: 'Willkommen in der Bat-Familie!', okText: 'Hier ist dein Rabattcode:',
      copy: 'Kopieren', copied: 'Kopiert!',
      okApplied: 'Er ist bereits in deinem Warenkorb hinterlegt: Der Rabatt wird an der Kasse abgezogen.',
      okManual: 'Gib ihn an der Kasse ein.',
      okNote: 'Einmal g\u00fcltig, bei deiner ersten Bestellung.',
      cont: 'Weiter einkaufen', close: 'Schlie\u00dfen'
    },
    es: {
      dialog: 'Oferta de bienvenida: 10\u00a0% de descuento',
      pct: '\u221210\u00a0%', sub: 'en tu primer pedido',
      eyebrow: 'Oferta de bienvenida', title: '\u00a1\u00danete a la Bat-familia!',
      text: 'D\u00e9janos tu correo: tu c\u00f3digo aparece al instante y te contaremos todas las novedades de Gotham.',
      label: 'Tu correo electr\u00f3nico', placeholder: 'Tu correo electr\u00f3nico',
      cta: 'Quiero mi \u221210\u00a0%', sending: 'Un momento\u2026', decline: 'No, gracias',
      legal: 'Al suscribirte, aceptas recibir nuestros correos (novedades y ofertas). Puedes darte de baja con un clic. V\u00e1lido una sola vez, en un primer pedido.',
      privacy: 'Pol\u00edtica de privacidad',
      errEmail: 'Esta direcci\u00f3n de correo no parece v\u00e1lida.',
      errNetwork: 'Vaya, algo ha fallado. Int\u00e9ntalo de nuevo en un momento.',
      okTitle: '\u00a1Te damos la bienvenida a la Bat-familia!', okText: 'Aqu\u00ed tienes tu c\u00f3digo de descuento:',
      copy: 'Copiar', copied: '\u00a1Copiado!',
      okApplied: 'Ya est\u00e1 aplicado a tu carrito: ver\u00e1s el descuento al pagar.',
      okManual: 'Introd\u00facelo al pagar.',
      okNote: 'V\u00e1lido una sola vez, en tu primer pedido.',
      cont: 'Seguir comprando', close: 'Cerrar'
    },
    it: {
      dialog: 'Offerta di benvenuto: 10% di sconto',
      pct: '\u221210%', sub: 'sul tuo primo ordine',
      eyebrow: 'Offerta di benvenuto', title: 'Entra nella Bat-famiglia!',
      text: 'Lascia la tua email: il codice appare subito e riceverai tutte le novit\u00e0 da Gotham.',
      label: 'Il tuo indirizzo email', placeholder: 'Il tuo indirizzo email',
      cta: 'Voglio il mio \u221210%', sending: 'Un attimo\u2026', decline: 'No, grazie',
      legal: 'Iscrivendoti accetti di ricevere le nostre email (novit\u00e0 e offerte). Puoi annullare l\u2019iscrizione con un clic. Valido una sola volta, su un primo ordine.',
      privacy: 'Informativa sulla privacy',
      errEmail: 'Questo indirizzo email non sembra valido.',
      errNetwork: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
      okTitle: 'Ti diamo il benvenuto nella Bat-famiglia!', okText: 'Ecco il tuo codice sconto:',
      copy: 'Copia', copied: 'Copiato!',
      okApplied: '\u00c8 gi\u00e0 applicato al tuo carrello: vedrai lo sconto al momento del pagamento.',
      okManual: 'Inseriscilo al momento del pagamento.',
      okNote: 'Valido una sola volta, sul tuo primo ordine.',
      cont: 'Continua lo shopping', close: 'Chiudi'
    }
  };
  /* </T> */

  // --------------------------------------------------------------- styles (Shadow DOM)
  // Charte Batman : jaune #fcd000, noir #0a0a0a, texte #222. Police du thème : Oswald (400 et 700).
  var CSS = [
    ':host{all:initial}',
    '*,*::before,*::after{box-sizing:border-box}',
    '[hidden]{display:none!important}',
    '.ov{--y:#fcd000;--y2:#ffd820;--k:#0a0a0a;--txt:#222;--mut:#6b6b6b;--line:#d4d4d4;',
    '--fd:Oswald,"Arial Narrow","Helvetica Neue",Arial,sans-serif;',
    'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;',
    'padding:24px;background:rgba(4,5,8,.7);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;',
    'transition:opacity .28s ease;font-family:var(--fd);font-size:16px;line-height:1.4;',
    'color:var(--k);text-align:left;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;',
    'overscroll-behavior:contain;-webkit-tap-highlight-color:transparent}',
    '.ov.on{opacity:1}',
    '.dlg{position:relative;display:grid;grid-template-columns:42% 58%;width:100%;max-width:780px;',
    'max-height:calc(100vh - 48px);background:#fff;border-radius:16px;overflow:hidden;outline:none;',
    'box-shadow:0 30px 90px rgba(0,0,0,.55),0 0 0 1px rgba(252,208,0,.38);transform:translateY(16px) scale(.97);opacity:.4;',
    'transition:transform .34s cubic-bezier(.2,.8,.2,1),opacity .34s ease}',
    '.ov.on .dlg{transform:none;opacity:1}',
    /* panneau visuel : nuit sur Gotham, bat-signal dans les nuages */
    '.vis{position:relative;z-index:0;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;',
    'min-height:450px;padding:34px 28px 116px;color:#fff;',
    'background:radial-gradient(85% 55% at 76% 15%,rgba(252,208,0,.22) 0%,rgba(252,208,0,0) 62%),',
    'linear-gradient(180deg,#1c2535 0%,#10151e 55%,#07090d 100%)}',
    '.vis.img{background:linear-gradient(180deg,rgba(10,10,10,.25) 0%,rgba(10,10,10,.70) 55%,rgba(5,5,5,.94) 100%),var(--img) center/cover no-repeat}',
    '.vis.img .stars,.vis.img .beam,.vis.img .glow,.vis.img .sig,.vis.img .city{display:none}',
    '.stars{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-4;opacity:.6;pointer-events:none;background-image:',
    'radial-gradient(1.3px 1.3px at 9% 12%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 24% 6%,#fff 50%,transparent 52%),',
    'radial-gradient(1.2px 1.2px at 38% 19%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 16% 31%,#fff 50%,transparent 52%),',
    'radial-gradient(1.4px 1.4px at 47% 7%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 6% 44%,#fff 50%,transparent 52%),',
    'radial-gradient(1.1px 1.1px at 31% 40%,#fff 50%,transparent 52%),radial-gradient(1px 1px at 55% 33%,#fff 50%,transparent 52%)}',
    '.beam{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-3;pointer-events:none;',
    'background:linear-gradient(205deg,rgba(252,208,0,.34) 0%,rgba(252,208,0,.12) 50%,rgba(252,208,0,0) 82%);',
    '-webkit-clip-path:polygon(9% 100%,16% 100%,93% 21%,58% 7%);clip-path:polygon(9% 100%,16% 100%,93% 21%,58% 7%)}',
    '.glow{position:absolute;top:14px;right:2px;width:196px;height:126px;border-radius:50%;z-index:-2;pointer-events:none;',
    'background:radial-gradient(closest-side,rgba(255,249,210,.98) 0%,rgba(252,208,0,.86) 50%,rgba(252,208,0,0) 100%)}',
    '.sig{position:absolute;top:14px;right:2px;width:196px;height:126px;z-index:-1;pointer-events:none}',
    '.city{position:absolute;left:0;right:0;bottom:0;width:100%;height:56%;z-index:-1;color:#030405;pointer-events:none}',
    '.band{position:absolute;left:-25%;right:-25%;bottom:-54px;height:126px;transform:rotate(-8deg);',
    'background:var(--y);box-shadow:0 -6px 0 rgba(0,0,0,.35);z-index:0}',
    '.band::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
    'background-image:radial-gradient(rgba(0,0,0,.2) 1.3px,transparent 1.7px);background-size:9px 9px}',
    '.off{position:relative;z-index:1;margin:0}',
    '.pct{display:inline-block;font-family:var(--fd);font-weight:700;font-size:98px;line-height:.95;letter-spacing:-.01em;',
    'white-space:nowrap;transform:skewX(-8deg);transform-origin:left bottom;color:#fff!important;',
    'text-shadow:4px 4px 0 var(--y),8px 8px 0 rgba(0,0,0,.55)}',
    '.sub{display:block;max-width:230px;margin-top:14px;font-size:14px;font-weight:700;line-height:1.3;',
    'letter-spacing:.14em;text-transform:uppercase;color:var(--y)!important;text-shadow:0 2px 8px rgba(0,0,0,.7)}',
    /* panneau formulaire */
    '.bd{position:relative;z-index:0;display:flex;flex-direction:column;justify-content:center;',
    'padding:44px 42px 30px;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.eb{display:inline-block;margin:0 0 14px;padding:5px 10px 4px;border-radius:4px;background:var(--y);',
    'font-size:13px;font-weight:700;line-height:1.2;letter-spacing:.16em;text-transform:uppercase;color:var(--k)!important}',
    '.title{margin:0 0 10px;font-family:var(--fd);font-size:36px;font-weight:700;line-height:1.06;letter-spacing:.005em;',
    'text-transform:uppercase;color:var(--k)!important;outline:none}',
    '.text{margin:0 0 22px;font-size:16.5px;line-height:1.5;color:var(--txt)!important}',
    '.fm{position:relative;margin:0}',
    '.in{display:block;width:100%;height:54px;margin:0;padding:0 16px;border:2px solid var(--line);border-radius:10px;',
    'background:#fff;color:var(--k);font:400 17px/1.2 var(--fd);letter-spacing:.02em;outline:none;',
    'box-shadow:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}',
    '.in::placeholder{color:#8a8a8a;opacity:1}',
    '.in:focus{border-color:var(--k);box-shadow:0 0 0 4px rgba(252,208,0,.6)}',
    '.in[aria-invalid="true"]{border-color:#b42318;box-shadow:0 0 0 4px rgba(180,35,24,.14)}',
    '.cta{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;',
    'margin:12px 0 0;padding:12px 20px;border:0;border-radius:10px;background:var(--y);color:var(--k)!important;',
    'font:700 18px/1.2 var(--fd);letter-spacing:.06em;text-transform:uppercase;',
    'text-align:center;cursor:pointer;box-shadow:0 5px 0 var(--k);-webkit-appearance:none;appearance:none;',
    'transition:transform .1s,box-shadow .1s,background-color .15s}',
    '.cta:hover{background:var(--y2)}',
    '.cta:active{transform:translateY(3px);box-shadow:0 2px 0 var(--k)}',
    '.cta:focus-visible,.copy:focus-visible,.no:focus-visible,.x:focus-visible,.legal a:focus-visible{outline:3px solid var(--k);outline-offset:3px}',
    '.cta[disabled]{cursor:progress;opacity:.82;transform:none}',
    '.cta svg{flex:none;width:18px;height:18px}',
    '.err{margin:10px 0 0;font-size:15px;line-height:1.4;color:#b42318!important}',
    '.err:empty{margin:0}',
    '.no{display:block;margin:12px auto 0;padding:6px 10px;border:0;background:none;color:var(--mut)!important;',
    'font:400 15px/1.3 var(--fd);letter-spacing:.02em;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.no:hover{color:var(--k)!important}',
    '.legal{margin:14px 0 0;font-size:12.5px;line-height:1.5;letter-spacing:.01em;color:var(--mut)!important}',
    '.legal a{color:var(--k)!important;text-decoration:underline;text-underline-offset:2px}',
    '.x{position:absolute;top:14px;right:14px;z-index:3;display:flex;align-items:center;justify-content:center;',
    'width:40px;height:40px;margin:0;padding:0;border:0;border-radius:50%;background:rgba(10,10,10,.07);',
    'color:var(--k);cursor:pointer;transition:background-color .15s,transform .2s}',
    '.x:hover{background:rgba(10,10,10,.14);transform:rotate(90deg)}',
    '.x svg{width:18px;height:18px}',
    '.sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',
    '.hp{position:absolute!important;left:-9999px;top:0;width:1px;height:1px;overflow:hidden}',
    /* étape « code » */
    '.okic{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:0 0 16px;border-radius:50%;',
    'background:var(--k);color:var(--y);box-shadow:0 0 0 7px rgba(252,208,0,.35)}',
    '.okic svg{width:28px;height:28px}',
    '.code{display:flex;align-items:center;gap:12px;margin:4px 0 14px;padding:10px 10px 10px 20px;',
    'border:2px dashed var(--k);border-radius:12px;background:#fffbe6;animation:bmpbPop .45s cubic-bezier(.2,.9,.3,1.35)}',
    '.codev{flex:1;min-width:0;font-family:var(--fd);font-size:30px;font-weight:700;letter-spacing:.12em;line-height:1.15;',
    'color:var(--k)!important;overflow-wrap:anywhere;-webkit-user-select:all;user-select:all}',
    '.copy{flex:none;min-height:44px;margin:0;padding:0 18px;border:0;border-radius:8px;background:var(--k);color:var(--y)!important;',
    'font:700 15px/1 var(--fd);letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:background-color .15s,color .15s}',
    '.copy.ok{background:#1d7d46;color:#fff!important}',
    '.hint{margin:0 0 6px;font-size:16px;line-height:1.5;color:var(--txt)!important}',
    '.note{margin:0;font-size:14px;line-height:1.5;color:var(--mut)!important}',
    '.cta-cont{margin-top:20px}',
    '@keyframes bmpbPop{from{transform:scale(.9);opacity:0}to{transform:none;opacity:1}}',
    /* téléphone : feuille qui monte du bas */
    '@media (max-width:719px){',
    '.ov{align-items:flex-end;padding:0;padding-bottom:var(--kb,0px)}',
    '.dlg{grid-template-columns:1fr;max-width:none;max-height:calc(100% - 12px);border-radius:20px 20px 0 0;transform:translateY(105%);opacity:1}',
    '.vis{min-height:0;flex-direction:row;align-items:center;justify-content:flex-start;padding:22px 64px 24px 22px;',
    'background:radial-gradient(70% 90% at 92% 0%,rgba(252,208,0,.24) 0%,rgba(252,208,0,0) 70%),linear-gradient(180deg,#1c2535 0%,#0b0f16 100%)}',
    '.off{display:flex;align-items:center;gap:16px}',
    '.pct{font-size:62px;text-shadow:3px 3px 0 var(--y),6px 6px 0 rgba(0,0,0,.5)}',
    '.sub{margin:0;max-width:150px;font-size:12px;letter-spacing:.12em}',
    '.band,.beam,.glow,.sig{display:none}',
    '.city{height:88%}.city .win{fill-opacity:.24}',
    '.x{top:12px;right:12px;background:rgba(255,255,255,.16);color:#fff}',
    '.x:hover{background:rgba(255,255,255,.28)}',
    '.x:focus-visible{outline-color:var(--y)}',
    '.bd{padding:24px 22px calc(18px + env(safe-area-inset-bottom,0px))}',
    '.title{font-size:28px}',
    '.text{margin-bottom:16px;font-size:15.5px}',
    '}',
    '@media (max-width:359px){.pct{font-size:50px}.title{font-size:24px}.bd{padding-left:18px;padding-right:18px}.vis{padding-left:18px}}',
    '@media (min-width:720px) and (max-height:620px){.vis{min-height:0;padding:24px 24px 100px}.pct{font-size:76px}',
    '.glow,.sig{width:160px;height:103px}.bd{padding:30px 36px 22px}.title{font-size:29px}.text{margin-bottom:14px}.legal{margin-top:10px}}',
    '@media (prefers-reduced-motion:reduce){.ov,.dlg,.cta,.x,.copy{transition:none!important}.code{animation:none!important}.dlg{transform:none!important}}'
  ].join('');

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    go: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
  };

  // Chauve-souris générique (dessin original, ailes festonnées, sans pointe de queue) : ce n'est
  // PAS l'emblème officiel. Boîte 120 × 50.
  var BAT = 'M60 18L57 19L55 11L52.5 20C49 21 47 22 46 23C38 14 22 8 5 10C10 17 12 24 14 31Q21 24 28 33' +
    'Q35 27 42 37Q49 31 54 40C56 44 58 46 60 46C62 46 64 44 66 40Q71 31 78 37Q85 27 92 33Q99 24 106 31' +
    'C108 24 110 17 115 10C98 8 82 14 74 23C73 22 71 21 67.5 20L65 11L63 19Z';

  // --------------------------------------------------------------- état
  var cfg, t, params, mode, forced, dry, reduced, coarse;
  var state = 'closed';
  var host = null, root = null, els = {}, lastFocus = null, sending = false, downOnBackdrop = false;
  var prevHtmlOverflow = null;

  try { boot(); } catch (err) { if (window.console) console.warn('[bmpb]', err); }

  function boot() {
    cfg = readConfig();
    if (!cfg) return;
    if (!('attachShadow' in Element.prototype) || !window.fetch || !window.URLSearchParams || !window.Promise) return;
    params = new URLSearchParams(window.location.search);
    mode = String(params.get('bmpb') || '').toLowerCase();
    forced = mode === 'show' || mode === 'test';
    var onLiveTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    dry = !!cfg.designMode || (mode === 'test' && !onLiveTheme);
    reduced = mq('(prefers-reduced-motion: reduce)');
    coarse = mq('(pointer: coarse)');
    window.bmpbPopup = { version: VERSION, open: function () { open({}); } };

    if (mode === 'reset') resetState();

    if (cfg.designMode) { setupEditor(); return; }

    // Arrivée depuis un e-mail marketing : déjà abonné.
    if (/^e-?mail$/i.test(params.get('utm_medium') || '')) store(K.sub, '1');

    // Retour d'une inscription.
    var postedOk = params.get('customer_posted') === 'true';
    var postedExisting = !postedOk && params.get('form_type') === 'customer';
    if (sget(K.pending) === '1') {
      sdel(K.pending);
      if (postedOk || postedExisting) {
        // l'inscription est passée par la page de vérification Shopify : on montre le code
        store(K.sub, '1');
        if (cfg.autoApply) applyCode();
        track('bmpb_subscribe', { status: postedOk ? 'ok-verif' : 'existing-verif' });
        setTimeout(function () { open({ success: true }); }, 400);
        return;
      }
    } else if (postedOk) {
      store(K.sub, '1'); // inscrit à l'instant par un autre formulaire (pied de page)
    }

    // Campagne Halloween en cours sur la page : elle passe en premier.
    if (!forced && halloweenActive()) return;

    if (!forced && !eligible()) return;
    schedule();
  }

  function readConfig() { return readJSON('bmpb-config'); }
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent || '{}');
      return c && typeof c === 'object' ? c : null;
    } catch (e) { return null; }
  }

  // Le pop-up Halloween est rendu par sa section tant que l'offre court ; on vérifie aussi la date ici.
  function halloweenActive() {
    var h = readJSON('bmph-config');
    if (!h || !h.enabled || h.designMode) return false;
    var fin = Number(h.fin);
    return !(isFinite(fin) && fin > 0 && Date.now() > fin);
  }

  function langOf(c) { return String((c && c.locale) || 'fr').toLowerCase().split(/[-_]/)[0]; }
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }

  // --------------------------------------------------------------- mémoire du navigateur
  function store(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { cookieSet(k, v, 400); } }
  function load(k) {
    var v = null;
    try { v = window.localStorage.getItem(k); } catch (e) { /* stockage bloqué */ }
    return v !== null ? v : cookieGet(k);
  }
  function unstore(k) { try { window.localStorage.removeItem(k); } catch (e) { /* rien */ } cookieSet(k, '', -1); }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* rien */ } }
  function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* rien */ } }
  function cookieGet(k) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(k, v, days) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) +
        '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* rien */ }
  }
  function resetState() {
    [K.sub, K.snooze, K.buyer].forEach(unstore);
    [K.t0, K.shown, K.pending].forEach(sdel);
  }
  function subscribed() { return load(K.sub) === '1'; }

  // --------------------------------------------------------------- qui voit le pop-up
  function eligible() {
    if (!cfg.enabled || !String(cfg.code || '').trim()) return false;
    if (isBot()) return false;
    if (subscribed()) return false;
    if (load(K.buyer) === '1') return false;
    if (sget(K.shown) === '1') return false;
    var until = parseInt(load(K.snooze) || '0', 10);
    if (until && Date.now() < until) return false;
    // filet de sécurité : le Liquid écarte déjà ces pages
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|challenge|password|policies|checkouts?)(?:[\/?#]|$)/i.test(window.location.pathname)) return false;
    return true;
  }

  function isBot() {
    return /googlebot|adsbot|storebot|google-inspectiontool|bingbot|bingpreview|yandex(?:bot|images|mobilebot)|baiduspider|duckduckbot|applebot|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|slurp|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|embedly|crawler|spider|lighthouse|pagespeed|headlesschrome|bot\//i
      .test(navigator.userAgent || '');
  }

  function delayMs() {
    var d = Number(cfg.delay);
    if (!isFinite(d)) d = 10;
    return Math.min(Math.max(d, 0), 600) * 1000;
  }

  function reshowMs() {
    var d = Number(cfg.reshowDays);
    if (!isFinite(d) || d < 1) d = 7;
    return Math.min(d, 365) * 864e5;
  }

  // Le délai court depuis l'ARRIVÉE sur la boutique, pas depuis chaque page : un visiteur
  // qui change de page au bout de 6 s voit le pop-up 4 s plus tard (2,5 s au minimum).
  function schedule() {
    var now = Date.now();
    var t0 = parseInt(sget(K.t0) || '', 10);
    if (!(t0 > 0) || t0 > now) {
      t0 = (window.performance && performance.timeOrigin) ? Math.round(performance.timeOrigin) : now;
      sset(K.t0, String(t0));
    }
    var wait = forced ? 1000 : Math.max(delayMs() - (now - t0), MIN_AFTER_LOAD);
    setTimeout(tryOpen, wait);
  }

  function tryOpen() {
    if (state !== 'closed') return;
    if (!forced && !eligible()) return;
    if (document.hidden) {
      var onVis = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        setTimeout(tryOpen, 1500);
      };
      document.addEventListener('visibilitychange', onVis);
      return;
    }
    if (busy()) { setTimeout(tryOpen, RETRY_BUSY); return; }
    open({});
  }

  // Ne jamais couvrir le menu, la recherche, une fenêtre du thème ou une saisie en cours.
  // Thème Craft (relevé le 2026-10-05) : menu mobile -> body.overflow-hidden-tablet, recherche ->
  // body.overflow-hidden ; menus déroulants et sélecteurs pays/langue -> details[open] ou
  // aria-expanded="true" dans l'en-tête. Le panier est une page, pas un tiroir.
  function busy() {
    var a = document.activeElement;
    if (a && a !== document.body) {
      if (a.isContentEditable || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') return true;
      if (a.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(a.type || '')) return true;
    }
    var b = document.body, h = document.documentElement;
    if (/(?:^|\s)(?:modal-open|js-drawer-open|overflow-hidden(?:-mobile|-tablet|-desktop)?)(?:\s|$)/.test(b.className || '')) return true;
    try {
      if (getComputedStyle(b).overflowY === 'hidden' || getComputedStyle(h).overflowY === 'hidden') return true;
      if (document.querySelector('.header details[open], header details[open], .header-wrapper details[open], ' +
        '.disclosure__button[aria-expanded="true"]')) return true;
    } catch (e) { /* rien */ }
    return false;
  }

  // --------------------------------------------------------------- éditeur de thème
  function setupEditor() {
    var ours = function (e) {
      return !!e && ((e.detail && e.detail.sectionId === SECTION_ID) ||
        (e.target && e.target.id === 'shopify-section-' + SECTION_ID));
    };
    document.addEventListener('shopify:section:select', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') teardown();
      open({});
    });
    document.addEventListener('shopify:section:deselect', function (e) { if (ours(e)) close('editor'); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg;
      if (state !== 'closed') { teardown(); open({}); }
    });
  }

  // --------------------------------------------------------------- construction
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function r1(x) { return Math.round(x * 10) / 10; }

  // Skyline de Gotham (dessin original) : tours à gradins, flèches gothiques, château d'eau, dôme ;
  // fenêtres allumées tirées au hasard, mais toujours les mêmes (graine fixe).
  function citySVG(cls, lit, winColor) {
    var W = 400, H = 170;
    var B = [ // [x, largeur, hauteur, toit] 0 plat · 1 flèche · 2 gradins · 3 château d'eau · 4 dôme · 5 pointe gothique
      [0, 30, 62, 0], [26, 24, 96, 1], [48, 38, 74, 3], [84, 22, 118, 5], [104, 44, 86, 2], [146, 30, 136, 2],
      [174, 36, 82, 0], [208, 24, 108, 1], [230, 48, 70, 0], [276, 28, 100, 4], [302, 40, 84, 2], [340, 26, 114, 5], [364, 36, 64, 0]
    ];
    var d = '', win = '', seed = 7, i, j, k;
    var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    for (i = 0; i < B.length; i++) {
      var x = B[i][0], w = B[i][1], h = B[i][2], roof = B[i][3], y = H - h, cx = x + w / 2;
      d += 'M' + x + ' ' + H + 'V' + y + 'H' + (x + w) + 'V' + H + 'Z';
      if (roof === 1) d += 'M' + r1(cx - 2.5) + ' ' + y + 'L' + r1(cx) + ' ' + (y - 28) + 'L' + r1(cx + 2.5) + ' ' + y + 'Z';
      if (roof === 2) d += 'M' + (x + 4) + ' ' + y + 'V' + (y - 10) + 'H' + (x + w - 4) + 'V' + y + 'Z' +
        'M' + (x + 9) + ' ' + (y - 10) + 'V' + (y - 19) + 'H' + (x + w - 9) + 'V' + (y - 10) + 'Z' +
        'M' + r1(cx - 0.8) + ' ' + (y - 19) + 'V' + (y - 36) + 'H' + r1(cx + 0.8) + 'V' + (y - 19) + 'Z';
      if (roof === 3) d += 'M' + (x + 9) + ' ' + y + 'V' + (y - 9) + 'H' + (x + 10.6) + 'V' + y + 'Z' +
        'M' + (x + 21) + ' ' + y + 'V' + (y - 9) + 'H' + (x + 22.6) + 'V' + y + 'Z' +
        'M' + (x + 6) + ' ' + (y - 9) + 'H' + (x + 26) + 'V' + (y - 21) + 'H' + (x + 6) + 'Z' +
        'M' + (x + 4.5) + ' ' + (y - 21) + 'L' + (x + 16) + ' ' + (y - 29) + 'L' + (x + 27.5) + ' ' + (y - 21) + 'Z';
      if (roof === 4) d += 'M' + x + ' ' + y + 'A' + r1(w / 2) + ' ' + r1(w / 2.3) + ' 0 0 1 ' + (x + w) + ' ' + y + 'Z' +
        'M' + r1(cx - 0.7) + ' ' + r1(y - w / 2.3) + 'V' + r1(y - w / 2.3 - 9) + 'H' + r1(cx + 0.7) + 'V' + r1(y - w / 2.3) + 'Z';
      if (roof === 5) d += 'M' + x + ' ' + y + 'L' + r1(cx) + ' ' + r1(y - w * 1.15) + 'L' + (x + w) + ' ' + y + 'Z' +
        'M' + r1(cx - 0.7) + ' ' + r1(y - w * 1.15) + 'V' + r1(y - w * 1.15 - 10) + 'H' + r1(cx + 0.7) + 'V' + r1(y - w * 1.15) + 'Z';
      for (j = y + 8; j < H - 6; j += 9) {
        for (k = x + 4; k < x + w - 5; k += 7) if (rnd() < lit) win += 'M' + k + ' ' + j + 'h3v4h-3z';
      }
    }
    return '<svg class="' + cls + '" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="currentColor"/>' +
      (win ? '<path class="win" d="' + win + '" fill="' + (winColor || '#fcd000') + '" fill-opacity=".72"/>' : '') + '</svg>';
  }

  // Bat-signal : la chauve-souris dans le halo, et deux nuages qui passent devant.
  function signalSVG() {
    return '<svg class="sig" viewBox="0 0 196 126" aria-hidden="true" focusable="false">' +
      '<path d="' + BAT + '" fill="#0a0a0a" fill-opacity=".9" transform="translate(48 36) scale(.84)"/>' +
      '<path d="M2 104c9-13 28-15 38-6 7-11 26-13 34-2 11-4 24 0 26 11H2z" fill="#151b25" fill-opacity=".94"/>' +
      '<path d="M116 30c6-8 18-9 25-3 5-6 16-6 21 1 7-2 14 2 15 8h-61z" fill="#151b25" fill-opacity=".72"/></svg>';
  }

  function markup() {
    var code = String(cfg.code || '').trim();
    var img = cfg.image ? String(cfg.image) : '';
    var visAttr = img ? ' class="vis img" style="--img:url(\'' + esc(img.replace(/['()\\]/g, '')) + '\')"' : ' class="vis"';
    return '' +
      '<div class="ov" part="overlay">' +
        '<div class="dlg" role="dialog" aria-modal="true" aria-labelledby="bmpb-t1" aria-describedby="bmpb-d1" tabindex="-1">' +
          '<button type="button" class="x" aria-label="' + esc(t.close) + '">' + ICON.x + '</button>' +
          '<div' + visAttr + '><span class="stars" aria-hidden="true"></span><span class="beam" aria-hidden="true"></span>' +
            '<span class="glow" aria-hidden="true"></span>' + signalSVG() + citySVG('city', 0.3) + '<div class="band"></div>' +
            '<p class="off"><span class="pct">' + esc(t.pct) + '</span><span class="sub">' + esc(t.sub) + '</span></p>' +
          '</div>' +
          '<div class="bd">' +
            '<div class="s-form">' +
              '<p class="eb">' + esc(t.eyebrow) + '</p>' +
              '<h2 class="title" id="bmpb-t1">' + esc(t.title) + '</h2>' +
              '<p class="text" id="bmpb-d1">' + esc(t.text) + '</p>' +
              '<form class="fm" novalidate>' +
                '<label class="sr" for="bmpb-email">' + esc(t.label) + '</label>' +
                '<input class="in" id="bmpb-email" type="email" name="contact[email]" required autocomplete="email" inputmode="email"' +
                  ' autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="send" aria-describedby="bmpb-err"' +
                  ' placeholder="' + esc(t.placeholder) + '">' +
                '<div class="hp" aria-hidden="true"><input type="text" name="bmpb_website" tabindex="-1" autocomplete="off"></div>' +
                '<button type="submit" class="cta cta-go"><span class="lbl">' + esc(t.cta) + '</span>' + ICON.go + '</button>' +
                '<p class="err" id="bmpb-err" role="alert" aria-live="assertive"></p>' +
              '</form>' +
              '<button type="button" class="no">' + esc(t.decline) + '</button>' +
              '<p class="legal">' + esc(t.legal) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') +
                '" target="_blank" rel="noopener">' + esc(t.privacy) + '</a></p>' +
            '</div>' +
            '<div class="s-ok" hidden>' +
              '<div class="okic">' + ICON.ok + '</div>' +
              '<h2 class="title" id="bmpb-t2" tabindex="-1">' + esc(t.okTitle) + '</h2>' +
              '<p class="text" style="margin-bottom:12px">' + esc(t.okText) + '</p>' +
              '<div class="code"><span class="codev">' + esc(code) + '</span>' +
                '<button type="button" class="copy">' + esc(t.copy) + '</button></div>' +
              '<p class="hint">' + esc(cfg.autoApply ? t.okApplied : t.okManual) + '</p>' +
              '<p class="note">' + esc(t.okNote) + '</p>' +
              '<button type="button" class="cta cta-cont">' + esc(t.cont) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function build() {
    destroyNow();
    t = T[langOf(cfg)] || T.en;
    host = document.createElement('div');
    host.id = 'bmpb-host';
    // z-index maximal : le pop-up passe au-dessus de la bulle Shopify Inbox (2147483000).
    // La vérification hCaptcha, ajoutée après, reste au-dessus du pop-up.
    host.setAttribute('style', 'position:relative!important;z-index:2147483647!important;display:block!important;');
    root = host.attachShadow({ mode: 'open' });
    root.innerHTML = '<style>' + CSS + '</style>' + markup();
    document.body.appendChild(host);

    var $ = function (s) { return root.querySelector(s); };
    els = {
      ov: $('.ov'), dlg: $('.dlg'), form: $('.fm'), email: $('.in'), hp: $('.hp input'),
      go: $('.cta-go'), lbl: $('.cta-go .lbl'), err: $('.err'), stepForm: $('.s-form'), stepOk: $('.s-ok'),
      okTitle: $('#bmpb-t2'), copy: $('.copy'), x: $('.x'), no: $('.no'), cont: $('.cta-cont')
    };
    if (cfg.email) els.email.value = String(cfg.email);

    els.ov.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === els.ov; });
    els.ov.addEventListener('click', function (e) {
      if (e.target === els.ov && downOnBackdrop) close('backdrop');
      downOnBackdrop = false;
    });
    els.x.addEventListener('click', function () { close('x'); });
    els.no.addEventListener('click', function () { close('decline'); });
    els.cont.addEventListener('click', function () { close('done'); });
    els.copy.addEventListener('click', copyCode);
    els.form.addEventListener('submit', onSubmit);
    els.email.addEventListener('input', function () {
      if (els.err.textContent) { els.err.textContent = ''; els.email.removeAttribute('aria-invalid'); }
    });
  }

  function destroyNow() {
    if (host && host.parentNode) host.parentNode.removeChild(host);
    host = null; root = null; els = {};
    state = 'closed';
  }

  // Démontage complet et immédiat (écouteurs, défilement, DOM). Sans risque si déjà fait.
  function teardown() {
    document.removeEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewport);
      window.visualViewport.removeEventListener('scroll', onViewport);
    }
    unlockScroll();
    destroyNow();
  }

  // --------------------------------------------------------------- ouverture / fermeture
  function open(opts) {
    opts = opts || {};
    if (state !== 'closed' || !document.body) return;
    build();
    state = 'open';
    if (!forced && !dry && !opts.success) sset(K.shown, '1');
    lastFocus = document.activeElement;
    lockScroll();
    document.addEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }
    if (opts.success) showSuccess(true);
    if (reduced) els.ov.classList.add('on');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (els.ov) els.ov.classList.add('on'); }); });
    setTimeout(function () {
      if (state !== 'open') return;
      var target = opts.success ? els.okTitle : (coarse ? els.dlg : els.email);
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }, reduced ? 0 : 80);
    track('bmpb_view', { success: !!opts.success });
  }

  function close(reason) {
    if (state !== 'open') return;
    state = 'closing';
    if (!dry && reason !== 'editor' && !subscribed()) store(K.snooze, String(Date.now() + reshowMs()));
    document.removeEventListener('keydown', onKey, true);
    unlockScroll();
    if (els.ov) els.ov.classList.remove('on');
    var finish = function () {
      if (state !== 'closing') return;
      teardown();
      var f = lastFocus;
      lastFocus = null;
      if (f && f.focus && document.documentElement.contains(f)) {
        try { f.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      }
    };
    if (reduced) finish(); else setTimeout(finish, 320);
    track('bmpb_close', { reason: reason });
  }

  // Bloque le défilement de la page derrière, sauf si ça ferait sauter la mise en page
  // (barre de défilement classique sur ordinateur).
  function lockScroll() {
    var h = document.documentElement;
    if (window.innerWidth - h.clientWidth > 0) return;
    prevHtmlOverflow = h.style.overflow;
    h.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (prevHtmlOverflow === null) return;
    document.documentElement.style.overflow = prevHtmlOverflow;
    prevHtmlOverflow = null;
  }

  // Clavier du téléphone ouvert : la feuille remonte au-dessus.
  function onViewport() {
    var vv = window.visualViewport;
    if (!vv || !els.ov) return;
    var kb = Math.round(window.innerHeight - vv.height - vv.offsetTop);
    els.ov.style.setProperty('--kb', (kb > 60 ? kb : 0) + 'px');
  }

  function focusables() {
    var list = els.dlg.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (n) { return n.offsetParent !== null; });
  }

  function onKey(e) {
    if (state !== 'open') return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], cur = root.activeElement;
    if (e.shiftKey && (cur === first || !cur || cur === els.dlg || cur === els.okTitle)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (cur === last || !cur)) { e.preventDefault(); first.focus(); }
  }

  // --------------------------------------------------------------- inscription
  function onSubmit(e) {
    e.preventDefault();
    if (sending) return;
    var email = String(els.email.value || '').trim();
    if (!EMAIL_RE.test(email)) { fail('email'); return; }
    if (els.hp.value) { succeed('hp'); return; } // robot : on fait semblant, rien n'est envoyé
    setSending(true);
    // Si la vérification anti-robot traîne (défi hCaptcha), le bouton redevient cliquable.
    var slow = setTimeout(function () { setSending(false); }, 12000);
    (dry ? simulate(email) : send(email)).then(function (outcome) {
      clearTimeout(slow);
      handle(outcome, email);
    }, function () {
      clearTimeout(slow);
      handle('network', email);
    });
  }

  function handle(outcome, email) {
    setSending(false);
    if (outcome === 'ok' || outcome === 'existing' || outcome === 'unknown') { succeed(outcome); return; }
    if (state !== 'open') return;
    if (outcome === 'challenge') { nativeSubmit(email); return; }
    fail(outcome === 'invalid' ? 'email' : 'network');
  }

  function setSending(on) {
    sending = !!on;
    if (!els.go) return;
    els.go.disabled = sending;
    els.go.setAttribute('aria-busy', sending ? 'true' : 'false');
    els.lbl.textContent = sending ? t.sending : t.cta;
  }

  function fail(kind) {
    if (state !== 'open') return;
    els.err.textContent = kind === 'email' ? t.errEmail : t.errNetwork;
    if (kind === 'email') {
      els.email.setAttribute('aria-invalid', 'true');
      try { els.email.focus({ preventScroll: true }); } catch (e) { els.email.focus(); }
    }
  }

  function succeed(kind) {
    if (!dry) store(K.sub, '1');
    if (!dry && cfg.autoApply && kind !== 'hp') applyCode();
    track('bmpb_subscribe', { status: kind, simulated: dry });
    if (state === 'open') showSuccess(false);
  }

  function showSuccess(instant) {
    els.stepForm.hidden = true;
    els.stepOk.hidden = false;
    els.dlg.setAttribute('aria-labelledby', 'bmpb-t2');
    els.dlg.removeAttribute('aria-describedby');
    if (!instant) setTimeout(function () {
      if (state !== 'open') return;
      try { els.okTitle.focus({ preventScroll: true }); } catch (e) { els.okTitle.focus(); }
    }, 30);
  }

  // Formulaire « miroir » hors Shadow DOM : c'est lui que Shopify protège (hCaptcha
  // invisible) et lui qui part, exactement comme le formulaire newsletter du pied de page.
  function templateForm() {
    var tpl = document.getElementById('bmpb-form-template');
    return tpl && tpl.content ? tpl.content.querySelector('form') : null;
  }

  var mirrors = 0;
  function makeMirror(email) {
    var src = templateForm();
    var f = document.createElement('form');
    f.id = 'bmpb-mirror-' + (++mirrors);
    f.method = 'post';
    f.setAttribute('action', (src && src.getAttribute('action') ? src.getAttribute('action') : '/contact').split('#')[0]);
    f.setAttribute('accept-charset', 'UTF-8');
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('style', 'position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;' +
      'height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;');
    var hidden = src ? src.querySelectorAll('input[type="hidden"]') : [];
    if (hidden.length) {
      Array.prototype.forEach.call(hidden, function (inp) {
        if (!inp.name) return;
        f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: inp.name, value: inp.value }));
      });
    } else {
      [['form_type', 'customer'], ['utf8', '\u2713'], ['contact[tags]', 'newsletter,pop-up email,pop-up email ' + langOf(cfg)]]
        .forEach(function (p) { f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: p[0], value: p[1] })); });
    }
    var em = Object.assign(document.createElement('input'), { type: 'hidden', name: 'contact[email]', value: email });
    em.setAttribute('value', email);
    f.appendChild(em);
    document.body.appendChild(f);
    return f;
  }

  function removeMirror(f) {
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }

  function send(email) {
    return new Promise(function (resolve) {
      var settled = false, posted = false;
      var mirror = makeMirror(email);
      var finish = function (outcome) {
        if (settled) return;
        settled = true;
        removeMirror(mirror);
        resolve(outcome);
      };
      var ajax = function () {
        if (posted) return;
        posted = true;
        post(mirror).then(finish, function () { finish('network'); });
      };
      // Shopify appelle cette fonction une fois le jeton anti-robot ajouté au formulaire.
      mirror.submit = ajax;
      var cap = window.Shopify && window.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var bound = false;
        try {
          cap.protect(mirror, function () {
            bound = true;
            try { mirror.submit(); } catch (err) { ajax(); }
          });
        } catch (err) { ajax(); return; }
        setTimeout(function () { if (!bound) ajax(); }, 20000);   // hCaptcha injoignable : envoi direct
        setTimeout(function () { finish('timeout'); }, 120000);  // défi abandonné
      } else {
        ajax();
      }
    });
  }

  function post(form) {
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { body.append(k, v); });
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 25000) : null;
    return fetch(form.getAttribute('action'), {
      method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow',
      headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      var url = res.url || '';
      if (/\/challenge(?:[\/?#]|$)/.test(url)) return 'challenge';
      if (!res.ok) return 'http';
      return res.text().then(function (html) { return classify(url, html); }, function () { return classify(url, ''); });
    });
  }

  // Shopify redirige : ?customer_posted=true (nouvel inscrit), ?…form_type=customer
  // (adresse déjà connue), /challenge (vérification). La section renvoie aussi un témoin
  // data-bmpb-state dans la page reçue.
  function classify(url, html) {
    var m = /data-bmpb-state="(ok|error)"(?:\s+data-bmpb-errors="([^"]*)")?/.exec(html || '');
    if (/[?&]customer_posted=true/.test(url) || (m && m[1] === 'ok')) return 'ok';
    if (m && m[1] === 'error') return /email/i.test(m[2] || '') ? 'invalid' : 'error';
    if (/[?&]form_type=customer/.test(url)) return 'existing';
    return 'unknown';
  }

  // Shopify exige une vérification visible : on envoie le formulaire normalement, la page
  // de vérification s'affiche, puis le retour sur la boutique ouvre le pop-up sur le code.
  function nativeSubmit(email) {
    sset(K.pending, '1');
    var f = makeMirror(email);
    HTMLFormElement.prototype.submit.call(f);
  }

  function simulate(email) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(/panne/i.test(email) ? 'http' : /erreur/i.test(email) ? 'invalid' : /existe/i.test(email) ? 'existing' : 'ok');
      }, 700);
    });
  }

  // Pose le code dans le panier (cookie de réduction Shopify) : il s'appliquera au paiement.
  function applyCode() {
    var code = String(cfg.code || '').trim();
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'),
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () { /* rien */ });
    } catch (e) { /* rien */ }
  }

  function copyCode() {
    var code = String(cfg.code || '').trim();
    var btn = els.copy;
    var done = function () {
      if (!btn) return;
      btn.textContent = t.copied;
      btn.classList.add('ok');
      track('bmpb_copy', {});
      setTimeout(function () { if (btn) { btn.textContent = t.copy; btn.classList.remove('ok'); } }, 2200);
    };
    var legacy = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.setAttribute('style', 'position:fixed;top:-1000px;left:0;opacity:0;');
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      try { btn.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      if (ok) done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, legacy);
    else legacy();
  }

  // Événements internes Shopify (lisibles par un pixel personnalisé). Rien n'est envoyé ailleurs.
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = { locale: langOf(cfg), version: VERSION };
        for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* rien */ }
  }
})();
